import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { JobIntakePage } from './features/intake/pages/JobIntakePage';
import { JobsPage } from './features/list/pages/JobsPage';
import { JOB_TABS } from './jobs.paths';
import { JobDetailPage } from './pages/JobDetailPage';

export const JOB_ROUTES: RouteObject[] = [
  { path: 'jobs', element: <JobsPage /> },
  { path: 'jobs/new', element: <JobIntakePage /> },
  ...recordTabRoutes('jobs/:id', JOB_TABS, (tab) => <JobDetailPage tab={tab} />),
];
